/** Per-tenant outcome catalog helpers (Progeny PS*, Soderberg SG*). */

import { supportsOutcomesCatalog } from "@/components/case-checking/agenticCaseCheck";

const FINAL_OUTCOME_ID = {
  progeny: "PS24",
  soderberg: "SG18",
} as const;

export function finalOutcomeId(companyId: string | undefined): string {
  if (companyId && Object.hasOwn(FINAL_OUTCOME_ID, companyId)) {
    return FINAL_OUTCOME_ID[companyId as keyof typeof FINAL_OUTCOME_ID];
  }
  return FINAL_OUTCOME_ID.progeny;
}

export function isFinalOutcomeId(companyId: string | undefined, outcomeId: string): boolean {
  return outcomeId === finalOutcomeId(companyId);
}

export { supportsOutcomesCatalog };
